import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import usePageTitle from '@/hooks/usePageTitle';
import CheckCircle from '@/images/CheckCircle.svg';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ConfettiAnimation from './images/ConfettiAnimation.json';

const Container = styled.div`
    background-color: white;
    height: 100vh;
    max-width: 100vw;

    align-items: center;
    position: relative;
`;

const Background = styled.div`
    position: absolute;
    display: flex;
    opacity: 0.5;
    left: 50%;
    transform: translateX(-50%);

    .lf-player-container {
        width: 450px;
    }
`;

const Content = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: 32px;
`;

const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 36px;
    font-weight: 700;
    letter-spacing: -0.72px;
`;

const Subtitle = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.15px;
    gap: 4px;

    a {
        color: ${({ theme }) => theme.colors.secondary[900]} !important;
    }
`;

const StyledButton = styled(Button)`
    height: 48px;
`;

const TITLE = 'Create Avatar - D-ID';

export const AvatarCreateSuccessPage = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    usePageTitle(TITLE);

    return (
        <Container>
            <Background>
                <Player src={ConfettiAnimation} autoplay />
                <Player src={ConfettiAnimation} autoplay />
            </Background>

            <Content>
                <MaskedIcon src={CheckCircle} size="72px" color={theme.colors.success[550]} />
                <Title>Your Avatar is being created</Title>
                <Subtitle>
                    Your <strong>Express Avatar</strong> will be ready soon.
                    <br />
                    We will send you an email when it’s ready.
                </Subtitle>
                <StyledButton
                    color="secondary"
                    onClick={() => navigate(AppRoutes.Avatars)}
                    size="large"
                    data-testid="avatar-create-success-done">
                    🎉 Done
                </StyledButton>
            </Content>
        </Container>
    );
};
